module.exports = __webpack_public_path__ + "static/media/go-lang.b4e19ff1.svg";